export default function JobRecruitmentModel({
  jobRecruitmentKey = -1,
  transDate = new Date(),
  title = "",
  description = "",
  isHired = false,
  closureRemarks = "",
  status = 0,
  statusDesc = "",
  docNum = "Auto No.",
  reason = "",
  createdBy = -1,
  createdByCode = "",
  createdDate = new Date(),
  updatedBy = -1,
  updatedByCode = "",
  updatedDate = new Date(),
  rowVersion = null,
  attaches = [],
  dets = [],
  exlevel = null,
  extitle = "",
  exgradekey = -1,
  exnoofreq = 0,
  exsalaryrec = 0,
  exdatereq = new Date("1900-01-01"),
  exoukey = -1,
  exwhstatus = null,
  exreason = null,
  exotherreason = "",
}) {
  return Object.freeze({
    JobRecruitmentKey: jobRecruitmentKey,
    TransDate: transDate,
    Title: title,
    Description: description,
    IsHired: isHired,
    ClosureRemarks: closureRemarks,
    Status: status,
    StatusDesc: statusDesc,
    DocNum: docNum,
    Reason: reason,
    CreatedBy: createdBy,
    CreatedByCode: createdByCode,
    CreatedDate: createdDate,
    UpdatedBy: updatedBy,
    UpdatedByCode: updatedByCode,
    UpdatedDate: updatedDate,
    RowVersion: rowVersion,
    Attaches: attaches,
    Dets: dets,
    EXLevel: exlevel,
    EXTitle: extitle,
    EXGradeKey: exgradekey,
    EXNoOfReq: exnoofreq,
    EXSalaryRec: exsalaryrec,
    EXDateReq: exdatereq,
    EXOUKey: exoukey,
    EXWHStatus: exwhstatus,
    EXReason: exreason,
    EXOtherReason: exotherreason,
  });
}
